module.exports = __webpack_public_path__ + "fonts/Barlow-ExtraBold.d3e19720.woff";